// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import default_home from './default_home'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 视频插件
import VideoPlayer from 'vue-video-player'
// 轮播图插件
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

Vue.use(ElementUI);
//获取数据的
import Resource from 'vue-resource'
Vue.use(Resource)
//jq的引入
import $ from 'jquery'
//公共js的引用
import common from './common/js/common.js'
//公共css的引用
import './common/css/media.css'
//引入数据
import myData from './data/data.js'
Vue.prototype.$myData = myData
Vue.prototype.$common = common 
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  components: {default_home},
  template: '<default_home/>'
})



// WEBPACK FOOTER //
// ./src/main.js